<template>
  <div class="private-cloud-resource-detail-content">
    <NetworkEdit ref="NetworkEdit" v-on:editComplete="init"></NetworkEdit>
    <CreateSubnet ref="CreateSubnet" v-on:createComplete="createSubnetComplete"></CreateSubnet>
    <PortEdit ref="PortEdit" v-on:editComplete="createPortComplete"></PortEdit>
    <Card shadow style="border-radius: unset">
      <a style="margin-right: 24px" v-on:click="$router.push({ name: 'network' })">
        <Icon type="md-arrow-round-back" size="18" />
      </a>
      <h3 style="color: #171d25; display: inline-block;">{{ info.name }}</h3>
      <div :style="{float: 'right'}">
        <Button size="small" type="warning" @click="$refs.NetworkEdit.modifyOpenModal(info)">编辑</Button>
      </div>
    </Card>
    <div class="main">
      <div>
        <Alert v-if="infoError" type="warning" show-icon>获取网络详情数据失败</Alert>
        <div class="info-property" v-else style="margin-right: unset;">
          <div class="resource-content-title">
            <h4>网络详情</h4>
          </div>
          <dl>
            <dt>网络名称</dt><dd>{{ info.name }}</dd>
          </dl>
          <dl>
            <dt>ID</dt><dd>{{ info.id }}</dd>
          </dl>
          <dl>
            <dt>状态</dt>
            <dd v-if="info.status === 'ACTIVE'">运行</dd>
            <dd v-else-if="info.status === 'DOWN'">不可用</dd>
            <dd v-else-if="info.status === 'BUILD'">构建中</dd>
            <dd v-else-if="info.status === 'ERROR'">错误</dd>
            <dd v-else>{{ info.status }}</dd>
          </dl>
          <dl>
            <dt>管理状态</dt>
            <dd v-if="info.admin_state_up"><span>是</span></dd>
            <dd v-else><span>否</span></dd>
          </dl>
          <dl>
            <dt>共享的</dt>
            <dd v-if="info.shared"><span>是</span></dd>
            <dd v-else><span>否</span></dd>
          </dl>
          <dl>
            <dt>外部网络</dt>
            <dd v-if="info['router:external']"><span>是</span></dd>
            <dd v-else><span>否</span></dd>
          </dl>
          <dl>
            <dt>MTU</dt>
            <dd>{{ info.mtu }}</dd>
          </dl>
          <dl>
            <dt>供应商网络</dt>
            <dd>
              <p><span>网络类型：</span>{{ info['provider:network_type'] }}</p>
              <p><span>物理网络：</span>{{ info['provider:physical_network'] }}</p>
              <p><span>段ID：</span>{{ info['provider:segmentation_id'] }}</p>
            </dd>
          </dl>
          <dl>
            <dt>创建时间</dt><dd v-if="info.created_at">{{ moment(info.created_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
          </dl>
          <dl>
            <dt>更新时间</dt><dd v-if="info.updated_at">{{ moment(info.updated_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
          </dl>
        </div>
        <div class="info-property" style="margin-right: unset;">
          <Row class="title" :style="{marginTop: '15px'}">
            <h4 :style="{float: 'left'}">子网</h4>
            <a v-on:click="$refs.SubnetList.getSubnets()" style="line-height: 32px; padding-left: 10px"><Icon type="md-refresh" size="18"/></a>
            <div :style="{float: 'right'}">
              <Button type="primary" @click="$refs.CreateSubnet.openModal(info.id, info.name)" style="margin-right: 10px">创建子网</Button>
            </div>
          </Row>
          <Row>
            <SubnetList ref="SubnetList" :network_id="$route.params.id"></SubnetList>
          </Row>
        </div>
        <div class="info-property" style="margin-right: unset;">
          <Row class="title" :style="{marginTop: '15px'}">
            <h4 :style="{float: 'left'}">端口</h4>
            <a v-on:click="$refs.PortList.getPorts()" style="line-height: 32px; padding-left: 10px"><Icon type="md-refresh" size="18"/></a>
            <div :style="{float: 'right'}">
              <Button type="primary" @click="$refs.PortEdit.openModal(info.id, info.name)" style="margin-right: 10px">创建端口</Button>
            </div>
          </Row>
          <Row>
            <PortList ref="PortList" :network_id="$route.params.id"></PortList>
          </Row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { detailPrivateCloudNetwork } from '@/api/private-cloud/network'
import NetworkEdit from './components/network-edit'
import CreateSubnet from './components/create-subnet'
import SubnetList from './components/subnet-list'
import PortList from './components/port-list'
import PortEdit from './components/port-edit'
import moment from 'moment'

export default {
  name: 'network-detail',
  components: {
    NetworkEdit,
    CreateSubnet,
    SubnetList,
    PortList,
    PortEdit
  },
  data () {
    return {
      info: {},
      infoError: false,
      moment: moment
    }
  },
  watch: {
    '$route' () {
      if (this.$route.params.id) {
        this.init()
      }
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.getInfo()
    },
    getInfo () {
      detailPrivateCloudNetwork(this.$route.params.id).then(res => {
        this.infoError = false
        this.info = res.data.network
      }).catch(res => {
        this.infoError = true
      })
    },
    createSubnetComplete () {
      this.init()
      this.$refs.SubnetList.getSubnets()
    },
    createPortComplete () {
      this.init()
      this.$refs.PortList.getPorts()
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../base.less';
</style>
